import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FileImage } from '../../../core/models/fileImage';
import { ConfigEntityService } from '../../../core/services/config-entity.service';
import { FormControl } from '@angular/forms';
import { distinctUntilChanged, debounceTime, Subscription } from 'rxjs';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { UserRoleNames } from 'src/app/core/models/users';

@Component({
  selector: 'app-images-list',
  templateUrl: './images-list.component.html',
  styleUrls: ['./images-list.component.scss']
})
export class ImagesListComponent implements OnInit {

  imagesList: FileImage[] = []
  filterText = new FormControl('');
  filteredImages: FileImage[] = [];
  constructor(
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    private configEntityService: ConfigEntityService,
    private navService: NavigationService,
    private authenticationService: AuthenticationService
  ) { }
  loggedInUserRole: string = this.authenticationService.getRole() || "";
  isMonitor: boolean = this.loggedInUserRole == UserRoleNames.Reader;
  currentActiveIndex: Number = 2;
  private cdRef = inject(ChangeDetectorRef);
  currentEntity: string = '';
  private breadcrumbSub!: Subscription;
  fromConfigurator: boolean = true;

  ngOnInit(): void {
    this.configEntityService.sendActiveEntity('Images');
    this.navService.sendChildData('Images');
    this.navService.sendParentData('');
    this.breadcrumbSub = this.navService.breadcrumbEntity.subscribe((x) => {
      this.currentEntity = x;
      if(!this.currentEntity || this.currentEntity === '' || this.currentEntity === 'Images') {
        this.fromConfigurator = false;
      }
    });
    // this.fetchImageList();
    // this.filterText.valueChanges
    //   .pipe(distinctUntilChanged(), debounceTime(300))
    //   .subscribe((value) => {
    //     this.filteredImages = this.imagesList.filter((img) =>
    //       img.name.toLowerCase().includes(value.toLowerCase()) || img.friendlyName.toLowerCase().includes(value.toLowerCase())
    //     || img.infrastructure.toLowerCase().includes(value.toLowerCase()) || img.platform.toLowerCase().includes(value.toLowerCase())
    //     );
    //   });
  }

  activeTab = 'registries';

  setActiveTab(tab: string) {
    console.log('Setting active tab to:', tab);
    this.activeTab = tab;
  }

  focusOnTab(index: Number) {
    this.currentActiveIndex = index;
    this.cdRef.detectChanges();
  }

  ngOnDestroy(): void {
    if (this.breadcrumbSub) {
      this.breadcrumbSub.unsubscribe();
    }
  }
}
